import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CheckoutProgressionStepsComponent } from '@checkout/feature-components';
import { CmsArea, CmsBrandPrivacyPolicyPipe } from '@domgen/dgx-fe-cms';
import { ButtonNavigateBackComponent } from '@domgen/dgx-fe-components/button';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import { InterpolatePipe } from '@domgen/dgx-fe-components/general';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GAPage } from '@domgen/dgx-fe-ga';
import { EditableArea } from '@magnolia/angular-editor';
import { MarketingPreferencesFormComponent } from '../../components/marketing-preferences-form/marketing-preferences-form.component';
import { MarketingPreferencesComponentService } from '../../services/marketing-preferences-component/marketing-preferences-component.service';

@Component({
  selector: 'checkout-marketing-preferences',
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonNavigateBackComponent,
    CardComponent,
    CheckoutProgressionStepsComponent,
    CmsBrandPrivacyPolicyPipe,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    InterpolatePipe,
    MarketingPreferencesFormComponent,
    NgIf,
  ],
  providers: [MarketingPreferencesComponentService],
  templateUrl: './marketing-preferences.component.html',
  styleUrls: ['./marketing-preferences.component.scss'],
})
@GAPage()
export class MarketingPreferencesComponent {
  @Input() main!: CmsArea;

  constructor(readonly cs: MarketingPreferencesComponentService) {}
}
